module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 1 April 2018, the Royal Air Force, the world’s first independent Air Force, turned 100. Celebrating the Centenary was a national event with numerous events staged up and down the country. The most striking was the massed parade and flypast down the Mall in front of Buckingham Palace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the presence of Her Majesty the Queen, one thousand Royal Air Force personnel marched on parade, while overhead flew a flypast of epic proportions. One hundred and three aircraft, representing the vast array of Royal Air Force military capability flew down the Mall starting at exactly 1300 hrs. To Commemorate, Celebrate and Inspire, the day’s events formed part of Royal Air Force history.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f008.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("One thousand Royal Air Force personnel marched on parade for Her Majesty the Queen on 10 July 2018 to mark the centenary birthday of the world’s first independent air force. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("© Crown Copyright 2018, WO Andy Malthouse")]), _vm._v(")")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f009.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book lets you in on the behind-the-scenes actions that brought the flypast to its majestic conclusion. Detailing the flypast’s initial conception, planning and managing the ‘What Ifs?’, it brings to life the challenges behind the event.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container2"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f009-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wing Commander Kevin Gatland OBE")])]), _vm._v(" "), _c('p', {
    staticClass: "rightindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("April 2020")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f009-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("© Crown Copyright 2018")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd8731a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Prologue.vue
// module id = 72
// module chunks = 0